module.exports = "<ion-content>\n\n</ion-content>\n"